<template>
  <span>
    <slot :calc="calc"></slot>
  </span>
</template>
<script>
let MILLISECONDS_SECOND = 1000;
let MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND;
let MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE;
let MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR;

let index = {
  name: "exam-countdown",

  data: function data() {
    return {
      remainingTime: 0,
      passedTime: 0
    };
  },

  props: {
    // start timestamp
    startTime: {
      type: Number,
      required: true
    },

    // duration in milliseconds
    duration: {
      type: Number,
      required: true
    },

    autoStart: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    calc() {
      return {
        days: Math.floor(this.remainingTime / MILLISECONDS_DAY),
        hours: Math.floor(
          (this.remainingTime % MILLISECONDS_DAY) / MILLISECONDS_HOUR
        ),
        minutes: Math.floor(
          (this.remainingTime % MILLISECONDS_HOUR) / MILLISECONDS_MINUTE
        ),
        seconds: Math.floor(
          (this.remainingTime % MILLISECONDS_MINUTE) / MILLISECONDS_SECOND
        ),
        passedTime: this.passedTime
      };
    }
  },

  methods: {
    start() {
      // check passed time every 200 milliseconds
      this.countdown_interval = setInterval(() => {
        let now = Date.now();
        this.passedTime = now - this.startTime;
        this.remainingTime = this.duration - this.passedTime;

        if (this.remainingTime <= 0) {
          this.end();
        }
      }, 200);
    },

    end() {
      this.remainingTime = 0;
      clearInterval(this.countdown_interval);
      this.$emit("countDownFinished");
    }
  },

  mounted() {
    if (this.autoStart) {
      this.start();
    }
  }
};

export default index;
</script>
